module.exports = __webpack_public_path__ + "static/media/39.1f33756c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/39.svg
// module id = 408
// module chunks = 14